import { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth-store';

export type ErrorType = 'auth' | 'network' | 'unknown' | null;

export function useApiError() {
  const [error, setError] = useState<string | null>(null);
  const [errorType, setErrorType] = useState<ErrorType>(null);
  const navigate = useNavigate();
  const logout = useAuthStore((s) => s.logout);

  const handleAuthRedirect = useCallback(() => {
    logout();
    navigate('/login', { replace: true });
  }, [logout, navigate]);

  const handleApiError = useCallback((err: any, customMessages?: {
    auth?: string;
    network?: string;
    unknown?: string;
  }) => {
    if (err?.response?.status === 401) {
      setError(customMessages?.auth ?? 'Tu sesión ha expirado. Inicia sesión nuevamente.');
      setErrorType('auth');
    } else if (err?.message === 'Network Error' || !err?.response) {
      setError(customMessages?.network ?? 'No se pudo conectar con el servidor. Verifica que el backend esté corriendo.');
      setErrorType('network');
    } else {
      setError(customMessages?.unknown ?? (err?.response?.data?.message || 'Error al cargar los datos.'));
      setErrorType('unknown');
    }
  }, []);

  const clearError = useCallback(() => {
    setError(null);
    setErrorType(null);
  }, []);

  return {
    error,
    errorType,
    setError,
    setErrorType,
    handleAuthRedirect,
    handleApiError,
    clearError,
  };
}
